import { IOption, IProductOption } from '../interfaces';

export const calcProductOptionsPrice = (options: IOption[]): number => {
    const price = options.reduce((sum, option) => {
        // const variantsSum = option.var
        const variantPrice = option.variants.reduce((sum, variant) => {
            const currentSum = variant.isDefault ? sum + variant.finalPrice : 0;

            return sum + currentSum;
        }, 0);
        return sum + variantPrice;
    }, 0);

    return price;
};

export const sortOptionToTop = (options: IOption[], type: string) => {
    return [...options].sort((x, y) => (x.type == type ? -1 : y.type == type ? 1 : 0));
};

export const getSelectedVariantIDs = (productOptions: IProductOption[]) => {
    const results = [];

    for (const productOption of productOptions) {
        const selectedVariantIDs = productOption.options.reduce((totalIds: any, option) => {
            const variants = option.variants;
            const variantIDs = variants.reduce((ids: number[], variant) => {
                const isSelected = variant.isDefault;

                return isSelected ? [...ids, variant.id] : ids;
            }, []);

            return [...totalIds, variantIDs];
        }, []);

        results.push({
            localeTypeId: productOption.localeType.id,
            variantIds: selectedVariantIDs.flat(),
        });
    }

    return results;
};
